"use client";

import React from "react";
import { ArrowRight, Sparkles, ShieldCheck, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheAirobotMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const missionValues = [{
    icon: <ShieldCheck className="size-5" />,
    title: "Clinical Precision",
    description: "Highest standards of medical excellence in every treatment."
  }, {
    icon: <Sparkles className="size-5" />,
    title: "Luxurious Restoration",
    description: "A sanctuary designed for profound sensory indulgence."
  }, {
    icon: <Zap className="size-5" />,
    title: "Instant Vitality",
    description: "Cutting-edge hydration techniques for immediate results."
  }];
  return <section data-section-id="223707" id="our-wellness-philosophy" className="bg-background text-foreground py-24 lg:py-40 relative overflow-hidden">
      {}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary/5 rounded-lg blur-[140px] pointer-events-none -translate-y-1/2 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-[800px] h-[800px] bg-primary/10 rounded-lg blur-[160px] pointer-events-none translate-y-1/2 -translate-x-1/4" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-12 blur-sm"}`}>
          {}
          <div className="lg:col-span-5 relative group order-2 lg:order-1">
            <div className="absolute -inset-4 bg-gradient-to-tr from-primary/20 to-transparent rounded-3xl blur-2xl opacity-30 group-hover:opacity-50 transition-opacity duration-1000" />
            
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden border border-primary/20 shadow-4xl bg-muted/20">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661213/img/wellness_sanctuary_interior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661213/img/wellness_sanctuary_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661213/img/wellness_sanctuary_interior.png-wvc-sizes" alt="Luxurious wellness sanctuary at Al Shifa Hydration Lounge" loading="lazy" className="w-full h-full object-cover transition-transform duration-1000 scale-105 group-hover:scale-100" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent opacity-60" />
              
              {}
              <div className="absolute bottom-6 left-6 right-6 p-6 bg-card/40 backdrop-blur-md border border-white/10 rounded-xl shadow-xl">
                <p className="font-serif text-lg italic text-white">
                  "Where clinical precision meets sensory indulgence."
                </p>
              </div>
            </div>

            {}
            <div className="absolute -bottom-8 -right-8 hidden lg:block w-32 h-32 border border-primary/30 rounded-2xl rotate-12 -z-10" />
          </div>

          {}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="max-w-2xl">
              <Badge variant="outline" className="mb-6 font-mono text-xs tracking-[0.2em] border-primary/40 text-primary bg-primary/5 px-4 py-1.5 uppercase rounded-lg">
                Our Philosophy
              </Badge>

              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold mb-8 text-foreground tracking-tight leading-[1.1]">
                The Al Shifa <br />
                <span className="text-primary font-light italic">Mission</span>
              </h2>

              <div className="space-y-6 text-lg text-muted-foreground leading-[1.618] font-default mb-12">
                <p>
                  At Al Shifa Hydration Lounge, we believe that true wellness is a 
                  harmonious blend of clinical precision and luxurious restoration. 
                  Our mission is to provide a sanctuary where elite IV therapy and 
                  advanced skin boosters meet the highest standards of medical 
                  excellence and personalized care.
                </p>
                <p>
                  By integrating essential vitamins and minerals with cutting-edge 
                  hydration techniques, we empower our clients to reclaim their 
                  vitality. We are dedicated to fostering a culture of rejuvenation, 
                  ensuring every visit leaves you feeling balanced, energized, 
                  and profoundly revitalized.
                </p>
              </div>

              {}
              <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-6 mb-12">
                {missionValues.map((value, i) => <div key={i} data-index={i} className="flex flex-col gap-3 p-4 rounded-xl border border-primary/10 bg-primary/5 hover:bg-primary/10 transition-colors duration-300">
                    <div className="text-primary">
                      {value.icon}
                    </div>
                    <h4 className="font-serif font-semibold text-sm text-foreground uppercase tracking-wider">
                      {value.title}
                    </h4>
                    <p className="text-xs text-muted-foreground leading-relaxed">
                      {value.description}
                    </p>
                  </div>)}
              </div>

              <div className="flex flex-wrap items-center gap-8 pt-8 border-t border-primary/20">
                <div className="flex flex-col">
                  <span className="font-mono text-[10px] text-primary uppercase tracking-[0.2em] mb-1">
                    Begin Your Journey
                  </span>
                  <span className="font-serif text-base text-foreground font-medium">
                    Discover our premium services
                  </span>
                </div>
                <Link to="/HomePage">
                  
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}